<template>
  <div class="relative text-black mt-4">
    <label class="flex flex-row">
      <input type="checkbox" v-model="checked" @input="onChange" />
      <p class="ml-2">Toon ook gesloten accommodaties</p>
    </label>
  </div>
</template>
<script>
export default {
  name: "IncludeClosedAccommodatiesSearch",

  data() {
    return {
      checked: false
    };
  },
  methods: {
    onChange() {
      // MIND: we negate this.checked, because somehow the value of checked is the inverse of what we expect/want
      const routename = this.$router.currentRoute.name;
      this.$store.dispatch("update_search", {
        selected: !this.checked,
        filtername: "include_closed",
        routename
      });
      if (routename !== "Home" && routename !== "TodoSearchResults")
        this.$router.push({ name: "Home" });
    }
  }
};
</script>
